import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { Button, HeaderText, Text } from '@el8/vital';
import cn from 'classnames';

import TextInputFormik from 'components/formik/TextInputFormik';
import MoneyInputFormik from 'components/formik/MoneyInputFormik';
import LockIcon from 'components/icons/LockIcon';

import styles from './PaymentDetailsForm.less';
import { PaymentDetailsValues } from '../helperTypes';

const PaymentDetailsForm: React.FC = () => {
  const { handleSubmit } = useFormikContext<PaymentDetailsValues>();

  const handleNext = useCallback((): void => {
    handleSubmit();
  }, [handleSubmit]);

  return (
    <>
      <HeaderText className={styles.header}>Make a patient payment</HeaderText>
      <div className={cn(styles.flexResponsive, styles.row)}>
        <TextInputFormik label="First name*" name="patient_first_name" className={styles.flex} />
        <TextInputFormik label="Last name*" name="patient_last_name" className={styles.flex} />
      </div>
      <div className={cn(styles.flexResponsive, styles.row)}>
        <MoneyInputFormik label="Amount*" name="amount_usd" className={styles.amount} />
        <TextInputFormik
          label="Statement or Invoice or Account #*"
          name="invoice_number"
          className={styles.flex}
        />
      </div>
      <div className={cn(styles.flexColumn, styles.row)}>
        <TextInputFormik
          label="Notes (related to the payment)"
          minRows={3}
          multiline
          name="notes"
          softMaxLength={500}
          className={styles.flex}
        />
      </div>
      <Button kind="primary" onClick={handleNext} text="Next" className={styles.button} />
      <div className={cn(styles.flexRow, styles.footer)}>
        <LockIcon style={{ marginRight: 'var(--vds-space-2xs' }} />
        <Text appearance="system">Secure payments powered by Elation Health &amp; Stripe</Text>
      </div>
    </>
  );
};

export default PaymentDetailsForm;
